import * as React from "react";
import AdminUserManagement from "../../Hub/Tabs/UserManagement";

const ProjectUserManagement = () => {
    return <AdminUserManagement/>
}

export default ProjectUserManagement;